<template>
  <el-tooltip v-if="img" class="align-middle" content="点击预览大图">
    <el-image
      style="height: 30px"
      :src="img"
      :preview-src-list="[img]">
    </el-image>
  </el-tooltip>
</template>

<script>
export default {
  props: {
    // 图片
    img: {
      // type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
